import React, { Component } from 'react';
import classNames from 'classnames';
import { addTranslation, IntlProps } from 'decorators/addTranslation';

import { Tab, TabsContainer as Tabs } from 'components/ui/tabs';

import FormFields from './FormFields';
import SubmittedForm from './components/submittedForm';

import FormFieldsProps from './FormFieldsProps';
import './formFields.scss';

interface Props extends FormFieldsProps, IntlProps {
  title?: string;
  subText?: string
  loadMore?: (name: string) => void;
}

class FormView extends Component<Props> {
  renderTabs = () => {
    const { tabs, getTranslate, onChangeTab, onBeforeChange } = this.props;

    if (!tabs) {
      return null;
    }

    return (
      <Tabs
        theme='brand'
        needUpdateDefaultTab
        defaultActiveTabIndex={tabs.findIndex((tab) => tab.isCurrent)}
        customClass='ui-form-fields__tabs ui-tabs_form-fields'
        onClick={onChangeTab}
        onBeforeChange={onBeforeChange}>
        {tabs.map((tab) => {
          return (
            <Tab key={tab.id} id={tab.id} title={getTranslate(tab.label)}>
              {this.renderFields()}
            </Tab>
          );
        })}
      </Tabs>
    );
  };

  renderFields = () => {
    const { formFields, filtersValues, fieldsConfig, filtersValuesCustom } =
      this.props;

    return formFields ? (
      React.cloneElement(formFields, {
        filtersValues: filtersValues,
        fieldsConfig: fieldsConfig,
      })
    ) : (
      <FormFields
        {...this.props}
        dictionaries={{
          ...filtersValues,
          ...filtersValuesCustom,
        }}
      />
    );
  };

  renderResult = () => {
    return (
      <SubmittedForm
        id={this.props.id}
        title={this.props.submittedTitle}
        text={this.props.submittedText}
        primaryButtonText={this.props.repeatCreateButtonText}
        onPrimaryButtonClick={this.props.onReset}
        status={this.props.status}
        secondaryButtonText={this.props.repeatBackText || this.props.backText}
        onSecondaryButtonLink={this.props.repeatBackUrl || this.props.backUrl}
        link={this.props.link}
      />
    );
  };

  render() {
    const { id, getTranslate } = this.props;

    return (
      <div
        className={classNames('ui-form-fields', `ui-form-fields_${id}`, {
          [`${this.props.customClass}`]: !!this.props.customClass,
        })}>
        {this.props.isSubmitted ? (
          this.renderResult()
        ) : (
          <>
            {this.props.title ? (
                <div className='ui-form-fields__container ui-form-fields__container_header'>
                  <div className='ui-form-fields__title'>
                    {getTranslate(this.props.title)}
                  </div>
                  {this.props.subText && (
                    <div className='ui-form-fields__subtext mt-4 text-l-regular'>
                      {this.props.subText}
                    </div>
                  )}
                </div>
            ) : null}
            {this.props.tabs ? this.renderTabs() : this.renderFields()}
          </>
        )}
      </div>
    );
  }
}

export default addTranslation(FormView);
